import React from 'react';

const SplashScreen = () => {
  return (
    <div className="w-screen h-screen flex flex-row justify-center items-center">
      Loading...
    </div>
  );
};

export default SplashScreen;
